define(['lz-string-master/libs/lz-string'], function (lzString) {
    function PkStorage() {
        var publics = {};
        var privates = {};

        privates.compress = !partyking.dev;
        privates.storageName =
            'pkstorage-' +
            partyking.config.cache_key +
            (privates.compress ? '-c' : '');
        privates.storageMethod = '';
        privates.api = '/storage/' + privates.storageName;
        privates.debug = '/debug/';
        privates.data = {};
        privates.saveToServerTimeoutMs = 200;
        privates.saveToServerTimeout = false;
        privates.events = {};
        privates.preventLocalTabEvent = false; //IE triggers storage event on localtab aswell
        privates.preventLocalTabEventTimeout = false; //IE fix
        privates.daysToLive = 7;

        publics.init = function () {
            if (publics.isStorageAvailable()) {
                privates.storageMethod = 'local';
            } else {
                privates.storageMethod = 'server';
            }

            privates.data = publics.loadStorage();
            privates.setEvents();
        };

        publics.reset = function () {
            privates.data = {};
            publics.save();
        };

        publics.clearLocalStorageButKeepData = function () {
            privates.data = publics.loadStorage();
            localStorage.clear && localStorage.clear();
            publics.save();
        };

        publics.loadStorage = function () {
            if (privates.storageMethod == 'local') {
                return publics.loadFromLocal();
            }

            return publics.loadFromServer();
        };

        publics.loadFromString = function (data) {
            try {
                try {
                    privates.data = JSON.parse(data);
                } catch (e) {
                    privates.data = JSON.parse(
                        partyking.common.helpers.decompress(data)
                    );
                }

                publics.moveExpiresForward();
                publics.save();
            } catch (e) {
                console.error(e);
            }
        };

        publics.storageToString = function () {
            return partyking.common.helpers.compress(
                JSON.stringify(privates.data)
            );
        };

        publics.loadFromServer = function () {
            var output = {};

            $.ajax({
                url: privates.api,
                type: 'GET',
                dataType: 'json',
                async: false,
                success: function (data) {
                    output = data;
                },
            });

            if (!_.isObject(output) || _.isArray(output)) {
                output = {};
            }

            return output;
        };

        publics.loadFromLocal = function () {
            var data = localStorage.getItem(privates.storageName);

            if (!data) {
                return {};
            }

            if (privates.compress) {
                data = lzString.decompressFromUTF16(data);
            }

            return JSON.parse(data);
        };

        publics.remove = function (key) {
            if (!_.isEmpty(privates.data[key])) {
                delete privates.data[key];
                publics.save();
            }
        };

        publics.get = function (key) {
            if (!_.isEmpty(privates.data[key])) {
                var now = new Date().getTime();

                if (now > privates.data[key].expires) {
                    delete privates.data[key];
                    publics.save();
                    return false;
                }

                return privates.data[key].data;
            }

            return false;
        };

        publics.moveExpiresForward = function () {
            $.each(privates.data, function (key, storageObject) {
                if (storageObject && storageObject.expires) {
                    storageObject.expires =
                        new Date().getTime() +
                        60 * 60 * 24 * 1000 * privates.daysToLive;
                }
            });
        };

        publics.set = function (key, data, secondsToLive) {
            var milliSecondsToLive = secondsToLive
                ? secondsToLive * 1000
                : 60 * 60 * 24 * 1000 * privates.daysToLive;
            var expires = new Date().getTime() + milliSecondsToLive;

            var storageObject = {
                data: data,
                expires: expires,
            };

            privates.data[key] = storageObject;

            publics.save();
        };

        publics.save = function () {
            if (privates.storageMethod == 'local') {
                try {
                    publics.saveToLocal();
                } catch (e) {
                    //on error saving to localStorage, switch to server storage
                    //console.error("Error saving to localStorage: ", e);
                    privates.storageMethod = 'server';
                    publics.saveToServer();
                }
            } else {
                publics.saveToServer();
            }
        };

        publics.saveToLocal = function () {
            privates.preventLocalTabEvent = true; //IE Fix

            if (privates.compress) {
                localStorage.setItem(
                    privates.storageName,
                    lzString.compressToUTF16(JSON.stringify(privates.data))
                );
            } else {
                localStorage.setItem(
                    privates.storageName,
                    JSON.stringify(privates.data)
                );
            }

            if (privates.preventLocalTabEventTimeout)
                clearTimeout(privates.preventLocalTabEventTimeout);

            privates.preventLocalTabEventTimeout = setTimeout(function () {
                privates.preventLocalTabEvent = false;
            }, 500);
        };

        publics.saveToServer = function (data) {
            if (privates.saveToServerTimeout)
                clearTimeout(privates.saveToServerTimeout);

            privates.saveToServerTimeout = setTimeout(function () {
                var success = false;

                $.ajax({
                    url: privates.api,
                    type: 'PUT',
                    data: JSON.stringify(privates.data),
                    contentType: 'application/json',
                    success: function (data) {
                        success = true;
                    },
                });
            }, privates.saveToServerTimeoutMs);
        };

        publics.isStorageAvailable = function () {
            var test = 'test';
            try {
                localStorage.setItem(test, test);
                localStorage.removeItem(test);
                return true;
            } catch (e) {
                return false;
            }
        };

        publics.on = function (eventName, cb) {
            if (!_.isArray(privates.events[eventName])) {
                privates.events[eventName] = [];
            }

            privates.events[eventName].push(cb);
        };

        publics.trigger = function (eventName) {
            if (_.isArray(privates.events[eventName])) {
                $.each(privates.events[eventName], function (key, val) {
                    if (_.isFunction(val)) {
                        val();
                    }
                });
            }
        };

        privates.setEvents = function () {
            $(window).on('storage', function () {
                privates.data = publics.loadStorage();

                window._klarnaCheckout &&
                    window._klarnaCheckout(function (api) {
                        api.suspend({
                            autoResume: {
                                enabled: false
                            }
                        });
                        api.resume();
                    });

                if (privates.preventLocalTabEvent) return true;

                if (_.isArray(privates.events['update'])) {
                    publics.trigger('update');
                }
            });

            $(window).on('focus', function () {
                privates.data = publics.loadStorage();

                if (_.isArray(privates.events['update'])) {
                    publics.trigger('update');
                }
            });
        };

        publics.createCookie = function (name, value, days) {
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
                var expires = '; expires=' + date.toGMTString();
            } else var expires = '';
            document.cookie = name + '=' + value + expires + '; path=/';
        };

        publics.readCookie = function (name) {
            var nameEQ = name + '=';
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) == 0)
                    return c.substring(nameEQ.length, c.length);
            }
            return null;
        };

        publics.eraseCookie = function (name) {
            createCookie(name, '', -1);
        };

        publics.debug = function (cb) {
            $.post(
                privates.debug,
                { data: JSON.stringify(privates.data) },
                function (data) {
                    if (cb) {
                        cb(data);
                    }
                }
            ).error(function () {
                if (cb) {
                    cb(false);
                }
            });
        };

        publics.init();
        return publics;
    }

    return PkStorage;
});
